import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import arrowLeft from "../assets/images/arrow-left.png";
import config from '../config/config';
import { getAssingedPrograms } from '../services/TeacherApi';
import LoadingSpinner from './LoadingSpinner';

const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

const AllocatedClasessAll = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAssignedPrograms();
  }, []);

  const fetchAssignedPrograms = async () => {
    try {
      const response = await getAssingedPrograms(user.user_data.id);
      setPrograms(response.data.programs || []);
    } catch (error) {
      console.error("Failed to fetch assigned programs", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className='app-container mobile-bottom'>
      <Container>

        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to='/teacherDashboard'><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Allocated Classes</h2>
        </div>
        <div>
          <h2 className='fs-20 fw-6 mt-3 mb-3'>
            <span className='small-hello fs-14'>Hello, </span>
            <span className='bigg-name'>{user?.user_data.name}!</span>
          </h2>

          <Row className='mb-3'>
            {programs.map((program) => (
              program.time_slots?.map((slot, idx) => (
                slot.time_ranges?.filter(tr => tr.teacher_id == user.user_data.id).map((time, timeIdx) => {
                  const skillLevel = program.skill_levels?.find(level => level.id === slot.skill_level_id);
                  return (
                    <Col xs='12' key={`${program.id}-${slot.id}-${timeIdx}`}>
                      <Card className='mb-3 border-0 p-0'>
                        <Link to={`/attendanceTeacher/${program.id}`}
                          state={{ programId: program.id, skillLevelId: slot.skill_level_id }} className='text-decoration-none text-dark'>
                          <Card.Body className='d-flex align-items-center p-0'>
                            <div className='program_img me-2'>
                              <img
                                src={`${config.Image_Base_URL}${program.program_image}`}
                                alt='program'
                                width={100}
                              />
                            </div>
                            <div className='program_content w-100'>
                              <Card.Title className='mb-1 fs-14 fw-6'>
                                {program.program_name} - {skillLevel ? `${skillLevel.skill_name} Level` : null}
                              </Card.Title>
                              {slot.focus?.title && (
                                <div className='fs-11 fw-5 mb-1'>{slot.focus.title}</div>
                              )}
                              <Card.Text className='mb-2 fs-12'>
                                {time.start_time} - {time.end_time}
                              </Card.Text>
                              <Card.Subtitle className='text-muted fs-12'>
                                {slot.week_days?.map(day => weekDays[day]).join(", ")}
                              </Card.Subtitle>
                            </div>
                          </Card.Body>
                        </Link>
                      </Card>
                    </Col>
                  );
                })
              ))
            ))}
          </Row>
        </div>
      </Container >
    </div >
  );
}

export default AllocatedClasessAll;